import { useState } from "react";

import { twMerge } from "tailwind-merge";

import Checkbox from "./checkbox";

export interface CheckboxItem {
  id?: string;
  label: string;
  value: string;
}

interface CheckboxListProps {
  items: CheckboxItem[];
  className?: string;
  selectedValue?: string[];
  onChange: (selectedIds: string[]) => void;
}

const CheckboxList = ({
  items,
  className,
  selectedValue = [],
  onChange
}: CheckboxListProps) => {
  const [selected, setSelected] = useState<string[]>(selectedValue);

  const handleCheckboxChange = (value: string, checked: boolean) => {
    let newSelectedList: string[];

    if (checked) {
      newSelectedList = [...selected, value];
    } else {
      newSelectedList = selected.filter(
        (selectedValue) => selectedValue !== value
      );
    }

    setSelected(newSelectedList);
    onChange(newSelectedList);
  };

  return (
    <div className={twMerge("flex gap-2 flex-wrap", className)}>
      {items.map((item) => (
        <Checkbox
          key={item.value}
          id={item.id}
          label={item.label}
          checked={selected.includes(item.value)}
          onChange={(checked) => handleCheckboxChange(item.value, checked)}
        />
      ))}
    </div>
  );
};

export default CheckboxList;
